<template>
  <CopyrightData v-slot="copyrightData">
    <div class="copyright-info">
      <div>
        {{ $t('main.copyright', { currentYear: copyrightData.buildYear }) }}
      </div>
      <div class="copyright-info__privacy">
        <span v-html="$t('main.footernav')" /> •
        <button
          v-if="copyrightData.hasCookiebot"
          data-test-id="open-cookiebot-button"
          class="copyright-info__cookie-consent-button"
          @click="copyrightData.showCookieConsentDialog"
        >
          {{ $t('main.cookieconsent') }}
        </button>
      </div>
      <div>
        <span :title="copyrightData.appVersion">{{ copyrightData.appVersion }}</span>
      </div>
    </div>
  </CopyrightData>
</template>

<script>
import { defineComponent } from 'vue';
import CopyrightData from '@components/CopyrightData.vue';

export default defineComponent({
  name: 'CopyrightInfo',

  components: {
    CopyrightData,
  },
});
</script>

<style lang="scss">
@use 'settings/colors';
@use 'mixins/typography';
@use 'mixins/linkstates';

.copyright-info {
  color: colors.$color-grey-500;
  width: 100%;

  @include typography.typography-13-normal(150%);
  text-overflow: ellipsis;

  div {
    padding: 4px 6px;
  }
}

.copyright-info__privacy {
  width: max-content;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  width: 100%;
}

.copyright-info a {
  @include linkstates.linkstates {
    color: inherit;
  }
}

.copyright-info__cookie-consent-button {
  color: inherit;
  font-size: inherit;
  height: 24px;
  border: none;
  background: transparent;

  &:hover,
  &:focus {
    background: none;
    border: none;
    box-shadow: none;
  }
}
</style>
